<template>
    <div class="page-content">
        <div v-if="!loading" class="white-box">
            <!-- <div class="white-box">
                <div class="table-header flex space-between align-center">
                    <div class="item-table-header">
                        <p class="red-text">Dashboard consultant</p>
                    </div>
                    <div class="item-table-header">
                        <p>Companii înscrise: <span class="green-bold">{{ totalCompanies }}</span></p>
                    </div>
                    <div class="item-table-header">
                        <p>Proiecte finalizate: <span :class="completedCompanies < totalCompanies ? 'red-danger' : 'green-bold'">{{ completedCompanies }}</span> / <span class="green-bold">{{ totalCompanies }}</span>
                        </p>
                    </div>
                    <div class="item-table-header no-border">
                        <img src="@/assets/images/M3/sketchconsultant.png" class="" alt="">
                    </div>
                </div>
            </div> -->
            <b-overlay :show="contractDownload">
                <b-table v-if="firme.length > 0" id="TabelContracte" sticky-header striped hover :items="firme"
                         :fields="fields" head-variant="light"
                >
                    <template v-slot:cell(id)="data">
                        <span>{{ ++data.index }}</span>
                    </template>
                    <template v-slot:cell(company)="data">
                        <span>{{ data.value }}</span>
                    </template>
                    <template v-slot:cell(suma)="data">
                        <span>{{ data.value }}</span>
                    </template>
                    <template v-slot:cell(licenses)="data">
                        <span>{{ data.value }}</span>
                    </template>
                    <template v-slot:cell(status)="data">
                        <span class="status-span"
                              :class="[data.value === 'Plata in asteptare' ? 'asteptare' : '', data.value === 'In asteptare' ? 'asteptare' : '', data.value === 'Platit' ? 'achitata' : '', data.value === 'Rambursat' ? 'anulat' : '', data.value === 'Anulat' ? 'anulat' : '']"
                        >{{
                            data.value
                        }}</span>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <div>
                            <span v-if="data.item.status !== 'Anulat' && ! data.item.invoice" v-b-tooltip.hover
                                  class="mr-3"
                                  :class="data.item.invoice ? 'not-ready' : (!data.item.estimate ? 'not-ready' : '')"
                                  :title="data.item.invoice ? 'Descarcă proforma' : (!data.item.estimate ? 'Proformă în curs de generare' : 'Descarcă proforma')"
                            >
                                <a :href="data.item.estimate ? data.item.estimate : '#'"><b-icon-download
                                    class="act-btn act-btn-up"
                                    icon="download"
                                    font-scale="1.85"
                                ></b-icon-download></a>
                            </span>
                            <span v-b-tooltip.hover class="mr-3" :class="!data.item.invoice ? 'not-ready' : ''"
                                  :title="getInvoiceTitle(data.item)"
                            >
                                <a :href="data.item.invoice ? data.item.invoice : '#'"><b-icon-download
                                    class="act-btn act-btn-up"
                                    icon="download"
                                    font-scale="1.85"
                                ></b-icon-download></a>
                            </span>
                            <span v-b-tooltip.hover class="mr-3" :class="!data.item.contract ? 'not-ready' : ''"
                                  :title="!data.item.contract ? 'Contract în curs de generare' : 'Descarcă contractul'"
                            >
                                <b-icon-download
                                    class="act-btn act-btn-up"
                                    icon="download"
                                    font-scale="1.85"
                                    style="cursor: pointer;"
                                    @click="downloadContract(data.item.contract)"
                                ></b-icon-download>
                            </span>
                            <span v-if="data.item.status !== 'Platit'" v-b-tooltip.hover
                                  :class="data.item.has_reference ? 'not-ready' : ''"
                                  :title="!data.item.has_reference ? 'Încarcă OP' : 'OP încărcat'" style="cursor: pointer"
                            >
                                <b-icon-upload
                                    :class="{'has-reference': data.item.has_reference, 'act-btn act-btn-up': true}"
                                    icon="upload"
                                    font-scale="1.6"
                                    @click="sendOp(data.item.id)"
                                ></b-icon-upload>
                            </span>
                            <input ref="fileUpload" type="file" style="display:none;" @change="uploadFile">
                        </div>
                    </template>
                </b-table>
                <div v-else class="no-licenses">
                    <img src="https://media.giphy.com/media/TU76e2JHkPchG/giphy.gif" alt="">
                    <p>Nu există momentan licențe achiziționate. <br> Poți achiziționa o licență folosind pagina
                        <router-link to="/aplicatii/m3-sketch/licente/comanda-licenta" class="green-bold">Comandă licență
                            nouă
                        </router-link>
                        .
                    </p>
                </div>
            </b-overlay>
        </div>
        <LoadingSpinner v-else style="min-height: 400px;"></LoadingSpinner>
    </div>
</template>


<script>
    import LoadingSpinner from '@/common/components/LoadingSpinner'
    import {
        BFormCheckbox,
        BTable,
        BIconX,
        BButton,
        BIconExclamationTriangleFill,
        BIconCheckCircleFill,
        BIconXCircleFill,
        BFormInput,
        BFormGroup,
        BIconUpload,
        BIconDownload,
        BTooltip,
        VBTooltip,
        BOverlay
    } from 'bootstrap-vue'
    import axios from '@/helpers/axios';
    import api from '@/helpers/api';
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import _ from 'lodash'

    export default {
        components: {
            SketchBreadcrumb,
            BFormCheckbox,
            BTable,
            BIconX,
            BIconExclamationTriangleFill,
            BIconCheckCircleFill,
            BIconXCircleFill,
            BFormInput,
            BFormGroup,
            BIconUpload,
            BIconDownload,
            BButton,
            BTooltip,
            LoadingSpinner,
            BOverlay
        },
        directives: {
            'b-tooltip': VBTooltip
        },
        props: {},
        data() {
            return {
                loading: true,
                contractDownload: false,
                selected: 1,
                selectedId: null,
                uploadedDocument: null,
                maxNumberOfFiles: 0,
                filesUploaded: 0,
                consultant: '',
                companies: [],
                fields: [
                    {
                        key: 'id',
                        label: 'Crt',
                        class: 'crtNumber',
                    },
                    {
                        key: 'company',
                        label: 'Beneficiar',
                        class: 'beneficiar-f',
                    },
                    {
                        key: 'suma',
                        label: 'Suma totală',
                        class: 'suma-factura',
                    },
                    {
                        key: 'licenses',
                        label: 'Număr de licențe',
                        class: 'numar-licente',
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        class: 'status-f'
                    },
                    {
                        key: 'actions',
                        label: 'Acțiuni',
                        class: 'actiuni-btns'
                    }
                ],
                firme: [],
                completedCompanies: null,
                totalCompanies: null,
            }
        },
        watch: {},
        mounted() {
            this.getCompanies()
        },
        methods: {
            getCompanies() {
                axios.get(api.API_ENDPOINTS.m3Payment)
                    .then(response => {
                        this.firme = []
                        response.data.payments.forEach(companie => {
                            this.firme.push({
                                id: companie.id,
                                company: companie.name,
                                suma: companie.total,
                                status: companie.status,
                                has_reference: companie.has_reference,
                                contract: companie.contract,
                                invoice: companie.invoice,
                                estimate: companie.estimate,
                                licenses: companie.licenses,

                            })
                            this.completedCompanies = _.filter(this.firme, v => v.progress === 100).length;
                            this.totalCompanies = this.firme.length
                        })
                    }).finally(() => {
                        this.loading = false
                    })
            },
            sendConsultant(id, consultant) {
                axios.post(api.API_ENDPOINTS.m3company + id + '/project', {consultant: consultant})
                    .then(() => {
                        this.$toast.success('Numele consultantului a fost actualizat.')
                    })
            },
            uploadFile(e) {
                let form = new FormData;
                if (e.target.files.length > 0) {
                    form.append('reference', e.target.files[0]);
                    form.append('_method', 'PUT');
                    axios.post(api.API_ENDPOINTS.invoices + '/' + this.selectedId + '/upload', form)
                        .then(response => {
                            this.getCompanies()
                            this.$toast.success(response.data.message);
                            this.$emit('getLicenseData')
                            this.uploadedDocument = null;
                            this.$refs.fileUpload.value = null;
                            this.selectedId = null
                        }).catch(() => {
                            this.$toast.error('Te rugăm încarcă un fisier in format PDF mai mic de 20MB.')
                        });
                }
            },
            downloadContract(link) {
                if (link) {
                    this.contractDownload = true
                    axios({url: link, method: 'GET', responseType: 'blob'})
                        .then((response) => {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'CONTRACT DE PRESTĂRI SERVICII.pdf');
                            document.body.appendChild(link);
                            link.click();
                            this.contractDownload = false
                        });
                }
            },
            sendOp(id) {
                let input = this.$refs.fileUpload;
                input.click()
                this.selectedId = id
            },
            getInvoiceTitle(item) {
                if (!item.invoice && item.status !== 'Anulat') {
                    return 'Factură în curs de generare'
                } else if (item.status === 'Anulat' && !item.invoice) {
                    return 'Factură anulată'
                } else {
                    return 'Descarcă factura'
                }
            }
        }
    }
</script>

<style>
#TabelContracte tr {
    background: rgba(0, 0, 0, 0.05) !important;
}

#TabelContracte .company-name-l {
    width: 65%;
}

#TabelContracte .license-status-l {
    width: 15%;
    max-width: 230px;
}

#TabelContracte .company-name-l span {
    width: 20%;
    max-width: 230px;
    color: #53596e;
}

#TabelContracte .activare-btn-l {
    width: 50%;
}

#TabelContracte th {
    font-size: 13px;
    font-weight: inherit;
}

#TabelContracte {
    text-align: center;
}

#TabelContracte td {
    padding: 0.45rem;
    vertical-align: middle;
}

@media screen and (max-width: 1240px) {
    #TabelContracte .actiuni-btns {
        width: 25%;
    }

    #TabelContracte .actiuni-btns .act-btn {
        padding: 2px 4px;
    }
}
</style>

<style scoped>
.green-bold {
    color: #49cda8 !important;
    font-weight: 700;
}

.white-box {
    background: #fff;
    padding: 20px;
    height: fit-content;
}

.no-licenses {
    min-height: 200px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.no-licenses p {
    font-size: 16px;
    text-align: center;
}

.no-licenses img {
    max-height: 205px;
    margin-bottom: 20px;
}

.not-ready {
    opacity: 0.3;
}

.act-btn {
    background-color: transparent;
    border: none;
    color: #777e90;
}

.has-reference {
    color: #49cda8;
}

.active-license,
.n-active-license {
    background: linear-gradient(to bottom, #8c6984, #816e8b);
    color: #fff;
    border-radius: 2px;
    padding: 3px 15px;
    font-size: 13px;
}

.n-active-license {
    background: #49cda8;
}

.n-active-license:hover {
    background: #36987d;
    transition: all 0.3s;
}

.has-icon {
    position: relative;
}

.has-icon img {
    position: absolute;
    top: 0;
    right: 10px;
    opacity: 0.3;
    bottom: 0;
    margin: auto 0;
}

#TabelContracte .red-bold {
    color: #ea8196 !important;
    font-weight: 700;
}

#TabelContracte .green-bold {
    color: #49cda8 !important;
    font-weight: 700;
}

.padding-box {
    padding: 20px 20px 0 20px;
}

.white-box {
    background: #fff;
}

.flex {
    display: flex;
}

.warn-icon {
    color: #ffc43f;
}

.danger-icon {
    color: #ea8196 !important
}

.success-icon {
    color: #49cda8 !important
}

.space-between {
    justify-content: space-between;
}

.justify-content-center {
    justify-content: center;
}

.table-header {
    font-size: 14px;
    color: #5b6276;
    font-weight: 500;
    min-height: 115px;
    padding: 0 20px;
}

tbody span {
    color: #777e90;
    font-size: 12px;
    font-weight: 500;
}

.form-group {
    margin: 0;
}

input {
    border-radius: 0;
    font-size: 13px;
    margin: 5px 0;
    color: #53596e;
    text-align: left;
    background: #e9ecef;
}

input:focus {
    color: #53596e;
    background: #e9ecef;
}

tr {
    text-align: center !important;
}

.absolute-left {
    position: absolute;
    left: 10%;
    bottom: 40%;
    z-index: 0;
}

.icons svg:not(:last-child) {
    margin-right: 10px;
}

.icons svg {
    font-size: 17px;
}

.padding-box .table-responsive {
    overflow-y: auto;
    max-height: calc(100% - 122px);
}

.b-table-sticky-header {
    max-height: calc(100% - 122px);
}

.b-table-sticky-header, .table-responsive {
    margin-bottom: 0;
}

.ml-1 {
    margin-right: 10px;
}

.item-table-header {
    width: 100%;
    height: 100%;
    min-height: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    border-right: 3px dotted #caccd2;
}

.item-table-header:last-child {
    border-right: 0;
}

.item-table-header p {
    font-size: 19px;
    color: #545a6f;
    letter-spacing: -0.3px;
    font-weight: 400;
}

.red-text {
    color: #836e8b !important;
}

.green-bold {
    color: #49cda8 !important;
    font-weight: 700;
}

.red-danger {
    color: #ea8196 !important;
}

.status-span {
    border-radius: 4px;
    padding: 3px 7px;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
}

.achitata {
    background: #49cda8;
}

.asteptare, .anulat {
    background: #b8b8b7;
}

@media (max-width: 1500px) {
    .item-table-header p {
        text-align: center;
    }

    .item-table-header img {
        max-height: 30px;
        object-fit: contain;
        padding: 0 10px;
    }

    .white-box {
        padding-right: 0;
    }
}

</style>
